'use client'

import * as React from 'react'
import { DeviceTypeContext } from './device-type-context'
import type { DeviceType } from '@/utils/getIsMobileServer'

type Props = {
  deviceType: DeviceType
  children: React.ReactNode
}

export const DeviceTypeProvider: React.FC<Props> = ({
  deviceType,
  children,
}) => {
  return (
    <DeviceTypeContext.Provider value={deviceType}>
      {children}
    </DeviceTypeContext.Provider>
  )
}
